<template>
  <div>
    <div class="ranking-list-dialog">
      <div class="ranking-list-items">
        <div class="item-top">
          <div v-if="top3.length > 0">
            <div class="left" v-if="top3.length > 1">
              <div> {{ processName(top3[1].clientName) }}</div>
              <div style="font-size:11px;margin-top: 5px;  color: #F9D96F;">已获得奖励 {{ top3[1].prizeCount }} 次</div>
            </div>
            <div class="middle" v-if="top3.length > 0">
              <div>{{ processName(top3[0].clientName) }}</div>
              <div style="font-size:12px;margin-top: 5px;  color: #F9D96F;">已获得奖励 {{ top3[0].prizeCount }} 次</div>
            </div>
            <div class="right" v-if="top3.length > 2">
              <div>{{ processName(top3[2].clientName) }}</div>
              <div style="font-size:10px;margin-top: 5px;  color: #F9D96F;"> 已获得奖励 {{ top3[2].prizeCount }} 次</div>
            </div>
          </div>
        </div>
        <div class="top3-tips">
        </div>
        <div class="rank-list">
          <div class="list-box1">
            <div class="left-title">排名</div>
            <div class="user">修理厂</div>
            <div class="flex-between">
              <div style="margin-right:10px">获得奖励总次数</div>
            </div>
          </div>
          <div class="scroll-list" v-if=" allRankingLists.length > 3">
            <van-list v-model="loading" :finished="finished" finished-text="没有更多了" offset="10" :immediate-check='false'
              @load="onLoad">
              <van-cell class="list-box2" v-for=" item in allRankingLists" :key="item.ranking" :border="false">
                <div class="flex-between my-info" v-if="item.ranking > 3">
                  <div style="margin-left:15px" class="left">{{ item.ranking }}</div>
                  <div style="text-align:left; width: 90px;">{{ processName(item.clientName) }}</div>
                  <div class="flex-between">
                    <div style="margin-right:10px">已获得奖励
                      <span style="color:#F9D96F">{{ item.prizeCount }} </span>次
                    </div>
                  </div>
                </div>
              </van-cell>
            </van-list>
          </div>

        </div>
      </div>
      <div class="my-ranking">
        <div class="flex-between">
            <div class="my-box " v-if="clientRanking">
              <div class="flex-top">
                <div  class="margin-up">{{ processName(userInfo.clientName) }}</div>
                <div >已获得奖励
                <span style="color:#F9D96F">{{ clientRanking.prizeCount }} </span>次
              </div>
              </div>
              <div >
                 您的排名是：
                 <span class="top-my" v-if="clientRanking.ranking <= 10">TOP{{ clientRanking.ranking }}</span>
                 <span class="top-my" v-else>{{ clientRanking.ranking }}</span>
                </div>
            </div>
            <div v-else class="no-ranking">
              暂未上榜
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import activityApi from '../../../api/activity'
import { userUtils } from '@/utils/auth'
export default {
  data () {
    return {
      loading: false,
      finished: false,
      page: 1,
      allRankingLists: [],
      clientRanking: [],
      top3: [],
      userInfo: []
    }
  },
  mounted () {
  },
  created () {
    this.userInfo = userUtils.getClientInfo()
    this.getRanking()
  },
  methods: {
    processName (clientName) {
      if (clientName) {
        if (clientName.length <= 7) {
          return clientName
        } else {
          let star = '****'
          return clientName.substr(0, 2) + star + clientName.substr(-2, 2)
        }
      }
    },
    // 底部刷新排名
    onLoad () {
      console.log('iiii')
      let page = this.page + 1
      let params = {
        page: page,
        pageSize: 14
      }
      activityApi.getCouponRanking(params).then(res => {
        if (res.data.resultCode === '0') {
          let itemList = res.data.resultData.taskRankingList || []
          this.allRankingLists = this.allRankingLists.concat(itemList)
          this.loading = false
          this.page++
          if (res.data.resultData.taskRankingList < 10) {
            this.finished = true
          }
        }
      })
    },
    getRanking () {
      let params = {
        page: this.page,
        pageSize: 14
      }
      activityApi.getCouponRanking(params).then(res => {
        if (res.data.resultCode === '0') {
          this.allRankingLists = res.data.resultData.taskRankingList
          this.clientRanking = res.data.resultData.clientRanking
          if (this.allRankingLists.length > 0) {
            this.top3 = this.allRankingLists.splice(0, 3)
          }
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
html {
  border: none;
}

// /deep/ .van-list {
//   background: url("../../../assets/images/activity/cards/ranking-infobox.png") no-repeat;
//   background-size: 100% auto;
//   background-color: rgba(255, 255, 255, 0);
//   width: 90%;
//   // height: 480px;
//   margin: 0 auto;
//   // overflow: scroll;
// }

/deep/ .van-cell {
  color: #fff;
  background-color: rgba(255, 255, 255, 0);
}

/deep/ .van-cell__value--alone {
  color: #fff;

}

.flex-between {
  display: flex;
  justify-content: space-between;
}

.img-box {
  margin: 1px;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: rgb(151, 150, 150);
}

.ranking-list-dialog {
  background: url("../../../assets/images/activity/cards/bg-ranking.png") no-repeat;
  background-size: 100% auto;
  width: 100%;
  height: auto;
  display: inline-block;

  .ranking-list-items {
    margin-top: 2px;

  }

  .item-top {
    background: url("../../../assets/images/activity/cards/top3.png") no-repeat;
    background-size: 100% auto;
    width: 97%;
    height: 223px;
    margin: 0 auto;
    position: relative;
    text-align: center;
    color: #fff;

    .left {
      font-size: 14px;
      position: absolute;
      left: 19px;
      bottom: 55px;
      width: 30%;
    }

    .middle {
      position: absolute;
      left: 31%;
      bottom: 65px;
      width: 40%;
    }

    .right {
      position: absolute;
      left: 68%;
      bottom: 55px;
      width: 28%;
    }
  }

  .top3-tips {
    background: url("../../../assets/images/activity/cards/ranking-tips.png") no-repeat;
    background-size: 100% auto;
    width: 100%;
    height: 30px;
  }

  .rank-list {
    background: url("../../../assets/images/activity/cards/ranking-infobox.png") no-repeat;
    background-size: 100% auto;
    background-color: rgba(255, 255, 255, 0);
    width: 90%;
    height: 500px;
    margin: 0 auto;
    color: #fff;
    // position: relative;

    .list-box1 {
      font-size: 10px;
      color: #fff;
      display: flex;
      line-height: 35px;
      font-weight: 300;
      justify-content: space-between;
      padding: 3px 0.42667rem;

      .left-title {
        margin-left: 10PX;
      }

      .user {
        width: 55px;
      }

      .left {
        font-size: 14px;
      }
    }

    .scroll-list {
      height: 450px;
      overflow: scroll;

      .list-box2 {
        font-size: 10px;
        color: #fff;
        display: flex;
        line-height: 35px;
        font-weight: 300;
        justify-content: space-between;
        padding: 5px 0.42667rem;

        .my-info {
          background: url("../../../assets/images/activity/cards/user-info.png") no-repeat;
          background-size: 100% auto;
          width: 100%;

          .img-box {
            margin: 1px;
            width: 40px;
            height: 40px;
            border-radius: 50%;
            background-color: rgb(151, 150, 150);
          }
        }

        .left {
          font-size: 16px;
          font-weight: 500;
          width: 50px;
        }
      }
    }

  }

  .my-ranking {
    background: url("../../../assets/images/activity/cards/my-ranking.png") no-repeat;
    background-size: 100% auto;
    width: 100%;
    height: 66px;
    z-index: 10000;
    position: fixed;
    bottom: 0;
    color: #fff;
    .no-ranking{
      width: 100%;
      text-align: center;
      margin-top: 25px;
    }
    .my-box{
      font-size: 12px;
      width: 100%;
      display: flex;
      justify-content: space-between;

      .flex-top{
      text-align: left;
      width: 40%;
      font-size: 12px;
      display: flex;
      flex-direction: column;
      margin-left: 20px;
      .margin-up{
        margin-top: 20px;
        margin-bottom: 7px;
      }
    }
    .top-my{
      text-align: right;
      width: 40%;
      font-size: 20px;
      font-style: italic;
      margin-right: 20px;
     line-height: 70px;
    }
    }

  }
}
</style>
